// Colores por tramo de antiguedad (de menor a mayor riesgo): corriente en
// verde, 31-60 azul, 61-90 ambar y > 90 rojo. El color sale del "orden" del
// tramo, no de su posicion en la dona, para que un tramo se lea igual en
// Cobrar y en Pagar aunque alguno no traiga todos los tramos.
export const COLORES_ANTIGUEDAD = ["#22a35a", "#2563eb", "#f5a524", "#ef4444", "#a855f7", "#64748b"];

// Gris de la dona cuando no hay deuda que repartir en tramos.
export const COLOR_SIN_DEUDA = "#e5e7eb";

export function colorTramo(orden) {
    return COLORES_ANTIGUEDAD[(orden - 1) % COLORES_ANTIGUEDAD.length];
}
